import DropDown from "../components/DropDown";
import { NavLink, Link } from "react-router-dom";
import React, { useState } from "react";
import logo from "../logo.png";
function Nav() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };
  const toggleClass = `${isOpen ? "block" : "hidden"}`;
  return (
    <div className="w-full top-0 left-0 sticky z-10 ">
      <Link to="/">
        <div className="logo  flex justify-between xl:px-32 lg:px-24 md:px-16 px-10 pt-6 py-8 items-center bg-white">
          <div className="md:h-10 h-6">
            <img src={logo} className="h-full" alt="" />
          </div>
          <div className="">
            <DropDown />
          </div>
        </div>
      </Link>
      <nav className="bg-black text-white xl:px-32 lg:px-24 md:px-16 px-10 py-4   ">
        <div className="flex justify-between items-center">
          <div className=" flex md:hidden">
            <button
              onClick={toggleNavbar}
              type="button"
              className="inline-flex items-center justify-center  rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:bg-gray-700 focus:text-white"
            >
              {isOpen ? (
                <svg
                  className="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              ) : (
                <svg
                  className="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              )}
            </button>
          </div>
          <div className="phone  text-xl items-center space-x-4 md:hidden ">
            <i class="fa-brands fa-facebook-f"></i>
            <i class="fa-brands fa-instagram"></i>
            <i class="fa-brands fa-linkedin"></i>
          </div>
        </div>
        <div
          className={`nav_content ${toggleClass} md:flex pt-4 md:pt-0 flex justify-between flex-col xl:flex-row space-y-2 xl:space-y-0`}
        >
          <div className="nav_links">
            <ul className="flex flex-col 2xl:space-x-10 xl:space-x-8 md:space-x-6 md:flex-row space-y-1 xl:space-y-0 font-semibold">
              <li>
                <NavLink onClick={toggleNavbar} to="/">
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink onClick={toggleNavbar} to="about">
                  About Us
                </NavLink>
              </li>
              <li>
                <NavLink onClick={toggleNavbar} to="shop">
                  {" "}
                  Deals In
                </NavLink>
              </li>
              <li>
                <NavLink onClick={toggleNavbar} to="offers">
                  {" "}
                  Special offer
                </NavLink>
              </li>
              <li>
                <NavLink onClick={toggleNavbar} to="contact">
                  {" "}
                  Contact Us
                </NavLink>
              </li>
            </ul>
          </div>
          <div className="nav_icons  flex justify-between md:space-x-5 pt-4 md:pt-0  ">
            <div className="flex sm:space-x-5 flex-wrap md:flex-nowrap  ">
              <div className="phone flex items-center space-x-2">
                <i class="fa-solid fa-phone"></i>
                <Link to="tel:+92 333 448 7714">
                  <p>+92 333 448 7714</p>
                </Link>
              </div>
              <Link to="mailto:ahsan@keylinesolution.com">
                <div className="phone flex items-center space-x-2 ">
                  <i class="fa-solid fa-envelope"></i>
                  <p>ahsan@keylinesolution.com</p>
                </div>
              </Link>
            </div>
            <div className="phone md:flex items-center space-x-4 hidden ">
              <i class="fa-brands fa-facebook-f"></i>
              <i class="fa-brands fa-instagram"></i>
              <i class="fa-brands fa-linkedin"></i>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Nav;
